/**
 * pubsub.subscribe-resource.js
 * Subscribe to message for Resources
 *
 * @package:  Betta
 * @version:  2.1
 * @author:   Cyrill N KALITA
 */
;(function($){
    /**
     * Listen to a success message
     */
    $.subscribe('resource.success',function(e, message){
        toastr.success(message)
    });

    /**
     * Listen to an info message
     */
    $.subscribe('resource.info',function(e, message){
        toastr.info(message)
    });

    /**
     * Listen to an error
     */
    $.subscribe('resource.error',function(e, message){
        toastr.error(message)
    });

    /**
     * Listen to a warning
     */
    $.subscribe('resource.warning',function(e, message){
        toastr.warning(message)
    });
})(jQuery);
